import React, { useState } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { Picture } from './Picture.jsx';
import { CssAnimation } from './CssAnimation.jsx';
import { TextContent } from './TextContent.jsx';
import { CORE_GTM_TRACKING_VALUES } from '../../constants/analytics.js';
import { fireGTMTrackingEvent } from '../../utilities/fireGTMTrackingEvent.js';

export function FeatureCard(props) {

  const { 
    heading, 
    headingSize,
    subheading, 
    body, 
    link, 
    media, 
    mediaMaintainAspect, 
    cssAnimation,
    cssAnimationTrigger, 
    cssAnimationDelay,
    onClickCallback,
    gtmComponentGroup, 
    gtmComponentName
  } = props;

  const [triggerCardAnimations, setTriggerCardAnimations] = useState(false);
  const block = 'c-feature-cards';
  const href = link?.url || link.href;
  let onClickCallbackDestination = '';

  if (onClickCallback) {
    onClickCallbackDestination = ("" + onClickCallback).replace(/.*navigate\(\'\.\./gs, '').replace(/\'\)\;.*/gs, '')
  }

  function clickHandler(e) {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.componentEvent,
      componentName: gtmComponentName,
      componentGroup: gtmComponentGroup,
      action: CORE_GTM_TRACKING_VALUES.action.clickLink,
      label: e.currentTarget.href || e.currentTarget.dataset.overlay || href || onClickCallbackDestination
    });

    if (onClickCallback) {
      onClickCallback(e);
    }
  };
  
  return (
    <div className={block}>
      <CssAnimation 
      enter={{ name: 'slide-up-fade-in', duration: 0.5, delay: `${cssAnimationDelay}, hidden`, easing: 'ease-out' }} 
      triggerEnter={cssAnimationTrigger}
      onEnterEnd={() => setTriggerCardAnimations(true)}
      disable={!cssAnimation}
      >
        <a 
        className={`${block}__card`}
        href={href} 
        draggable='false' 
        tabIndex={-1}
        onClick={clickHandler}
        {...( link.overlay && { 'data-overlay': link.overlay } )}
        >
          <div className={`${block}__card-inner`}>
            <TextContent 
            heading={heading} 
            headingSize={headingSize}
            subheading={subheading} 
            body={body}
            cssAnimation={cssAnimation}
            cssAnimationTrigger={triggerCardAnimations}
            />
            {
              link.label &&
                <button className={`${block}__card-button c-button__cta cmp-btn btn-tertiary`}>
                  { link.label }
                </button>
            }
          </div>
          <CssAnimation 
          enter={{ name: 'vertical-top-bottom-reveal', target: 'psuedo-element-after', duration: 0.75, delay: 0, easing: 'ease-out' }} 
          triggerEnter={triggerCardAnimations} 
          disable={!cssAnimation}
          >
            <div
            className={
              classNames({
                [`${block}__media`]: true,
                [`${block}__media--maintain-aspect`]: mediaMaintainAspect
              })
            }
            >
              {/* 
              TODO - ADD VIDEO SUPPORT WITH HOVER PLAYBACK AS PER PRESALES COMPONENT. 
              <video className='c-media__video  c-media__video--fit' muted playsInline preload='metadata' data-selector='video'>
                <source src={`${media.url}#t=0.01`} type="video/mp4" />
              </video> 
              */}
              <Picture 
              base={media.url}
              className={
                classNames({
                  'c-media__image': true,
                  'c-media__image--fit': !mediaMaintainAspect
                })
              }/>
            </div>
          </CssAnimation>
        </a>
      </CssAnimation>
    </div>
  )
};

FeatureCard.propTypes = {
  heading: propTypes.string.isRequired,
  headingSize: propTypes.string,
  subheading: propTypes.string,
  body: propTypes.string,
  link: propTypes.object,
  media: propTypes.object.isRequired,
  mediaMaintainAspect: propTypes.bool,
  cssAnimation: propTypes.bool,
  cssAnimationTrigger: propTypes.oneOfType([
    propTypes.string,
    propTypes.bool
  ]),
  onClickCallback: propTypes.func,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string
};

FeatureCard.defaultProps = {
  heading: 'HEADING',
  subheading: 'SUBHEADING',
  media: {
    type: 'image',
    url: '/resources/images/RX-article-1.png'
  },
  mediaMaintainAspect: false,
  cssAnimation: true,
  cssAnimationTrigger: 'in-view-init',
  cssAnimationDelay: 0,
  gtmComponentName: CORE_GTM_TRACKING_VALUES.componentName.featureCard,
  gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.campaigns
};